<template>
  <Layout>
    <div v-if="!show_ie">
      <!-- <Appdowload></Appdowload> -->
      <div class="bordertop3">
        <div class="header">
          <HeaderNav name="2"></HeaderNav>
        </div>
        <div>
          <div class="train" :style="train_list.length<=4?'height:900px':''">
            <div class="train-bar">
              <ul>
                <a v-for="(tab,i) in tabs" :key="i">
                  <li
                    @click="changeTab(i)"
                    class="inlineblock train-bar-item"
                    :class="{active:tab_id==tab.id}"
                  >{{tab.category_name}}</li>
                </a>
              </ul>
            </div>
            <div class="train-sub-bar">
              <div class="sub-ul" v-if="tabs[tab_key]">
                <span>分类：</span>
                <div
                  v-for="(sub_tab,index) in tabs[tab_key].child" :key="index"
                  @click="changeSubTabId(sub_tab.id)"
                  class="inlineblock train-bar-item sub_item"
                  :class="{active:sub_tab_id==sub_tab.id}"
                >
                  <div class="pointer">{{sub_tab.category_name}}</div>
                </div>
              </div>
            </div>
            <div style="margin-top: 25px;">
              <div class="exam-list">
                <div v-for="(train,key) in train_list" :key="key" class="train-list-item">
                  <div @click="goDetail(train)" class="pointer">
                    <a>
                      <div class="img">
                        <img
                          v-if="train.image_url!=undefined && train.image_url.length>0"
                          :src="train.image_url[0]"
                        />
                        <img v-else src="https://file.jkxuetang.com/khyoga/banner.jpg" />
                        <!-- <div
                          v-if="train.dijia!='' && train.dijia!=undefined"
                          :class="train.dijia!='' && train.dijia!=undefined?'lowest-price':''"
                        >
                          <div
                            class="lowest-price-left text-nowrap"
                            v-if="train.status!=2"
                          >最低特惠价可低至：￥{{train.dijia}}</div>
                        </div> -->
                      </div>
                    </a>

                    <div class="detail">
                      <div class="text-nowrap">{{train.train_name}}</div>
                      <div class="price">
                        <div class="before-price" v-if="train.status!=2">
                          <span v-if="train.dijia != '' && train.dijia != undefined && train.dijia != null && train.before_promotion_time != '' && train.before_promotion_time != undefined && train.before_promotion_time != null">￥{{train.dijia}}-{{train.before_promotion_time}}</span>
                          <span v-else>￥{{train.price}}</span>
                        </div>
                        <div class="before-price" v-else>预售中</div>
                        <!-- <div
                          class="youhui-money"
                          v-if="train.promotion_time!=undefined && train.promotion_time!=''"
                        >
                          <span style="color:#999;font-size:14px">
                            {{train.promotion_time}}前报名特惠价:
                            <span
                              style="font-size:14px;color: #FF4560;"
                            >￥{{train.before_promotion_time}}</span>
                          </span>
                        </div> -->
                      </div>
                      <div class="date">
                        <p v-if="train.status!=2">截止报名日期：{{train.reg_end_time}}</p>
                        <p v-else>截止报名日期：- -</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="train_list.length<=0 && !isfirstload">
                <Norecord></Norecord>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- :parentToChild="footstyle" -->
       <!-- :style="train_list.length<=4?'position: fixed;bottom:0;margin-top:20px':''" -->
      <FooterDes></FooterDes>
    </div>
    <HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import pages from "../../components/Page";
import norecord from "../../components/NoRecord";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    HeaderNav: headernav,
    FooterDes: footer,
    Pages: pages,
    Norecord: norecord,
    Appdowload: Appdowload,
    HintIE: HintIE
  },
  data() {
    return {
      tab_id: 0,
      tab_key: 0,
      tabs: [],
      sub_tab_id: 0,
      // page:1,
      train_list: [],
      show_ie: false,
      footstyle: "",
      isfirstload: true
    };
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)
        this.show_ie = true; //不支付IE
    },
    goDetail(val) {
      if (val.status != 2) {
        this.$router.push({ path: "/train/detail?id=" + val.id });
      }
    },
    changeTab: function(key) {
      //拿到一级的下标，然后拿获取的下标去获取对应的一级id，实现动态css，
      this.tab_key = key;
      this.tab_id = this.tabs[key].id;
      if (
        this.tabs[key].child != undefined &&
        this.tabs[key].child.length > 0
      ) {
        this.changeSubTabId(this.tabs[key].child[0].id);
      } else {
        this.changeSubTabId(0);
      }
    },

    changeSubTabId: function(sub_tab_id) {
      this.sub_tab_id = sub_tab_id;
      if (sub_tab_id == 0) {
        this.train_list = [];
      } else {
        this.getTrainList(sub_tab_id);
      }
    },
    getTrainList: function(sub_tab_id) {
      var that = this;
      that.isfirstload = false;
      getData(config.apimethod.getTrainList + "?id=" + sub_tab_id, function(
        res
      ) {
        var data = res.data.train;
        that.train_list = data;
      });
    },
    getTrainCateList: function() {
      var that = this;
      getData(config.apimethod.getTrainCateList, function(res) {
        var data = res.data;
        that.tabs = data;
        that.tab_key = 0;
        that.tab_id = data[0].id;
        if (data[0].child != undefined && data[0].child.length > 0) {
          that.changeSubTabId(data[0].child[0].id);
        } else {
          that.changeSubTabId(0);
        }
      });
    }
  },
  mounted() {
    this.getTrainCateList();
    this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}

.indexnews .ivu-card-body {
  padding: 0;
}

.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/train/index.vue